var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-wrap"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"img-wrap"},_vm._l((_vm.pdfImages),function(img,i){return _c('img',{key:i,attrs:{"src":img}})}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }